export default "__VITE_ASSET__k85Q56Jb__"